
import { Box } from '@mui/material';
import React, { FC, ReactNode } from 'react';


const AbschlussSeiteBox: FC<{ children: ReactNode }> = ({ children }) => {
	return <Box sx={{ width: '100%', mt: '1rem' }}>{children}</Box>;
};
export default AbschlussSeiteBox;
